var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6608 6.05078L9 16.6025L18 6.05078H12.6608Z",
    fill: "#FFE182"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72414 1.39648L0 6.05167H5.33921L3.72414 1.39648Z",
    fill: "#FFCD73"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6606 6.05167H17.9999L14.2757 1.39648L12.6606 6.05167Z",
    fill: "#FFCD73"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6609 6.05167L9.00014 1.39648L5.33936 6.05167H12.6609Z",
    fill: "#FFCD73"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99974 1.39648H3.72388L5.33896 6.05167L8.99974 1.39648Z",
    fill: "#FFAA64"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2759 1.39648H9L12.6608 6.05167L14.2759 1.39648Z",
    fill: "#FFE182"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33936 6.05078L9.00014 16.6025L12.6609 6.05078H5.33936Z",
    fill: "#FFAA64"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.05078L9 16.6025L5.33921 6.05078H0Z",
    fill: "#FF8C5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.71c8e00b.svg";
export { ForwardRef as ReactComponent };